// filter view option in ProductsGrid component
export const FilterType = Object.freeze({
	All: 'All',
	Category: 'Category',
	Tag: 'Tag',
	Search: 'Search',
});
